import { styled } from "@mui/material/styles";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { authentication } from "zebdsh.login.authentication";
import * as Utils from "../utils/Utils";
import { SideNavElement } from "./SideNavElement";
const App_list = styled("ul")(({ theme }) => ({
    listStyle: "none",
}));
export const SideNavApps = observer((props) => {
    var _a, _b;
    const [appMapOpen, setAppMapOpen] = useState(false);
    const [menuAppItems, setMenuAppItems] = useState([]);
    const [categoryIdSelected, setCategoryIdSelected] = useState("");
    const [authInfo, setAuthInfo] = useState(props.appModel.authInfo);
    const pathToStatic = props.appModel.pathToStatic;
    const pathToApi = props.appModel.pathToAppFrameApi;
    const i18n = props.appModel.i18n.bind(props.appModel);
    const lang = props.appModel.language;
    const defaultLang = props.appModel.config.defaultLanguage;
    let gotoHomeUrl = props.appModel.appState.homeUrl;
    useEffect(() => {
        let authSubscription = props.appModel.subscribeToAuthChanged((newAuthInfo) => {
            setAuthInfo(newAuthInfo);
        });
        Utils.fetchAsync(pathToApi + "menu/apps", null, (value) => {
            if (value == null) {
                setMenuAppItems([]);
            }
            else {
                setMenuAppItems(value);
            }
        });
        return () => {
            authSubscription.unsubscribe();
        };
    }, []);
    const toggleApplicationMap = () => {
        if (appMapOpen) {
            setAppMapOpen(false);
        }
        else {
            setAppMapOpen(true);
        }
    };
    const closeApplicationMap = () => {
        setAppMapOpen(false);
    };
    const renderApps = () => {
        try {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "application-map__body" },
                    React.createElement("div", { role: "navigation", className: "navigation navbar-top" },
                        React.createElement(App_list, { className: "clearfix navbar-nav__item" }, menuAppItems.map((menuAppItem, i) => {
                            if (menuAppItem.apps["de"].length > 0) {
                                return (React.createElement("li", { className: "nav-item", key: "menulink_" + menuAppItem.id + "_li_cat" },
                                    React.createElement("span", { className: "nav-link application-map__category" +
                                            ("menulink_" + menuAppItem.id ==
                                                categoryIdSelected
                                                ? " application-map--is-selected"
                                                : ""), id: "menulink_" + menuAppItem.id, key: "menulink_" + menuAppItem.id + "_span", onClick: (event) => {
                                            setCategoryIdSelected(event.target.id);
                                        } }, menuAppItem.label["de"]),
                                    React.createElement("div", { className: "application-map__apps-mobile", key: "menulink_" + menuAppItem.id + "_div_mobile_cont" },
                                        React.createElement("div", { className: "application-map__category-container" +
                                                ("menulink_" + menuAppItem.id ==
                                                    categoryIdSelected
                                                    ? " application-map__category-container--is-visible"
                                                    : ""), key: "menulink_" + menuAppItem.id + "_div_mobile" },
                                            React.createElement(App_list, { className: "clearfix navbar-nav__item", key: "menulink_" + menuAppItem.id + "_ul_mobile" }, menuAppItem.apps["de"].map((app, j) => (React.createElement("li", { className: "nav-item", key: "menulink_" +
                                                    menuAppItem.id +
                                                    "_" +
                                                    String(j) +
                                                    "_li_mobile" },
                                                React.createElement("a", { href: app.url, className: "nav-link", key: "menulink_" +
                                                        menuAppItem.id +
                                                        "_" +
                                                        String(j) +
                                                        "_a_mobile" }, app.label)))))))));
                            }
                        }))),
                    React.createElement("div", { className: "application-map__apps" }, menuAppItems.map((menuAppItem, i) => {
                        if (menuAppItem.apps["de"].length > 0) {
                            return (React.createElement("div", { className: "application-map__category-container" +
                                    ("menulink_" + menuAppItem.id == categoryIdSelected
                                        ? " application-map__category-container--is-visible"
                                        : ""), key: "menulink_" + menuAppItem.id + "_div" },
                                React.createElement(App_list, { className: "clearfix navbar-nav__item", key: "menulink_" + menuAppItem.id + "_ul" }, menuAppItem.apps["de"].map((app, j) => (React.createElement("li", { className: "nav-item", key: "menulink_" +
                                        menuAppItem.id +
                                        "_" +
                                        String(j) +
                                        "_li" },
                                    React.createElement("a", { href: app.url, className: "nav-link", key: "menulink_" +
                                            menuAppItem.id +
                                            "_" +
                                            String(j) +
                                            "_a" }, app.label)))))));
                        }
                    })))));
        }
        catch (ex) {
            console.error(ex);
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "application-map__body" })));
        }
    };
    const doLogin = () => {
        props.appModel.login();
    };
    const doLogout = () => {
        props.appModel.logout();
    };
    const doReset = () => {
        props.appModel.passwordReset();
    };
    const renderLoginButton = () => {
        if (props.authInfo.isAuthenticated == true) {
            return (React.createElement(React.Fragment, null,
                React.createElement("button", { type: "button", value: i18n("appsmenu.login.button.logout"), onClick: doLogout, className: "login-button" }, i18n("appsmenu.login.button.logout")),
                React.createElement("button", { type: "button", value: i18n("appsmenu.login.button.pwdreset"), onClick: doReset, disabled: !authentication.isInitialized(), className: "login-button" }, i18n("appsmenu.login.button.pwdreset"))));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("button", { type: "button", value: i18n("appsmenu.login.button.login"), onClick: doLogin, className: "login-button" }, i18n("appsmenu.login.button.login"))));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "block-applicationmap", className: "block block-zeb-portal block-application-map" },
            React.createElement("div", { className: "content" },
                React.createElement(SideNavElement, { id: "applicationMapToggle", title: i18n("appsmenu.alt"), onClick: toggleApplicationMap, imageSrc: pathToStatic + "images/icon_applications.svg", appModel: props.appModel }),
                React.createElement("div", { id: "applicationMap", className: appMapOpen
                        ? "application-map application-map--is-opened"
                        : "application-map" },
                    React.createElement("div", { className: "application-map__menu" },
                        React.createElement("div", { className: "application-map__inner-content" },
                            React.createElement("div", { className: "application-map__header" },
                                React.createElement("div", { className: "title" }, i18n("appsmenu.title")),
                                React.createElement("div", { className: "application-map__buttonbar" },
                                    React.createElement("div", { className: "application-map__buttonbar-item" },
                                        React.createElement("a", { href: gotoHomeUrl },
                                            React.createElement("img", { className: "application-map-nav__item--icon", src: pathToStatic + "images/icon_home.svg", alt: i18n("general.gotoHome") }))),
                                    React.createElement("div", { id: "applicationMapClose", className: "application-map__buttonbar-item", onClick: closeApplicationMap },
                                        React.createElement("img", { className: "application-map-nav__item--icon", src: pathToStatic + "images/icon_close.svg", alt: i18n("general.close") })))),
                            renderApps(),
                            React.createElement("div", { className: "block-currentuser", style: {
                                    fontFamily: "BrownStd-Regular", //"var(--default-font-family)",
                                    fontSize: "1.6rem", //"var(--default-text-font-size)",
                                } },
                                React.createElement("table", { className: "application-map__current-user" },
                                    React.createElement("tbody", null,
                                        React.createElement("tr", null,
                                            React.createElement("td", null, i18n("appsmenu.login.title")),
                                            React.createElement("td", null, (_a = authInfo === null || authInfo === void 0 ? void 0 : authInfo.displayName) !== null && _a !== void 0 ? _a : "")),
                                        React.createElement("tr", null,
                                            React.createElement("td", null),
                                            React.createElement("td", null, (_b = authInfo === null || authInfo === void 0 ? void 0 : authInfo.userName) !== null && _b !== void 0 ? _b : "")))),
                                React.createElement("div", null, renderLoginButton())))),
                    React.createElement("div", { className: "application-map__shadow" }))))));
});
export default SideNavApps;
